import './filename-formatter-form.css';
import { useEffect, useState } from 'react';
import { Button, Form, Select, Space } from 'antd';
import { highlight, languages } from 'prismjs';
import Editor from 'react-simple-code-editor';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism.css';

import ClientSelect from '../../component/client-select';
import { FilenameFormatter } from '../../model/filename-formatter-model';

const typeOptions = [
    { value: 'main', label: 'Main' },
    { value: 'auxiliary', label: 'Auxiliary' },
    { value: 'zip', label: 'Zip' },
];

interface FilenameFormatterFormProps {
    formatter?: FilenameFormatter;
    defaultClientId?: number;
    onClose: () => void;
    onSubmit: (formatter: FilenameFormatter) => void;
}

const FilenameFormatterForm = ({ formatter, defaultClientId, onClose, onSubmit }: FilenameFormatterFormProps) => {

    const [form] = Form.useForm();
    const [code, setCode] = useState<string>('');

    useEffect(() => {
        form.setFieldsValue({
            clientId: formatter?.clientId ?? defaultClientId,
            type: formatter?.type,
        });
        setCode(formatter?.formatter ?? '');
    }, [formatter, defaultClientId]);

    const onFinish = (values: any) => {
        onSubmit({
            ...formatter,
            ...values,
            formatter: code,
        });
    }

    return <Form
        form={form}
        className="filename-formatter-form"
        layout="vertical"
        onFinish={onFinish}
    >
        <h2>{formatter ? 'Edit Filename Formatter' : 'Create Filename Formatter'}</h2>

        <Form.Item
            label="Client"
            name="clientId"
            rules={[{ required: true, message: 'Client is required.' }]}
        >
            <ClientSelect />
        </Form.Item>

        <Form.Item
            label="Type"
            name="type"
            rules={[{ required: true, message: 'Type is required.' }]}
        >
            <Select options={typeOptions} placeholder="Select a formatter type" />
        </Form.Item>

        <Form.Item label="Formatter Script">
            <div className="filename-formatter-editor">
                <Editor
                    value={code}
                    onValueChange={setCode}
                    highlight={(code) => highlight(code, languages.js!, 'js')}
                    padding={10}
                    style={{
                        minHeight: 300,
                        background: 'white',
                        fontFamily: '"Fira code", "Fira Mono", monospace',
                        fontSize: 14,
                    }}
                />
            </div>
        </Form.Item>

        <Form.Item>
            <Space style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button onClick={onClose}>Cancel</Button>
                <Button type="primary" htmlType="submit">Save</Button>
            </Space>
        </Form.Item>
    </Form>
};

export default FilenameFormatterForm;
